import React, { useState, useEffect } from "react";
import "./Adminpage.css";
import AdminNav from "../../../components/AdminNav/AdminNav";
import { useUser } from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";

export default function Adminpage() {
  const { user, loading } = useUser();
  const [articleCount, setArticleCount] = useState(0);
  const [url, setUrl] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const [embedId, setEmbedId] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the number of articles from the API
    fetch(`${apiUrl}/articles/count`)
      .then((res) => res.json())
      .then((data) => setArticleCount(data.count))
      .catch((error) => console.error("Error fetching article count:", error));
  }, [apiUrl]);

  useEffect(() => {
        fetch(`${apiUrl}/video-config`)
            .then(res => res.json())
            .then(data => setUrl(data.youtube_url))
            .catch(error => console.error("Error fetching video:", error));
    }, [apiUrl]);

  // compute embed id whenever url changes
  useEffect(() => {
    const id = extractYouTubeId(url);
    setEmbedId(id);
  }, [url]);

  function extractYouTubeId(input) {
    if (!input) return null;
    // Accept raw id or full URLs. Try to extract from common YouTube URL formats.
    const idOnly = input.match(/^[a-zA-Z0-9_-]{6,}$/);
    if (idOnly) return idOnly[0];

    // Patterns: youtu.be/ID, v=ID, /embed/ID
    const regex = /(?:youtube(?:-nocookie)?\.com\/(?:.*v=|v\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/;
    const m = input.match(regex);
    return m ? m[1] : null;
  }

const handleSubmit = (e) => {
    e.preventDefault();
  setStatusMessage('');
  setSaving(true);

    // Get your token from storage
    const token = localStorage.getItem('token'); 

    fetch(`${apiUrl}/admin/video`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({ 
            youtube_url: url,
        })
    })
  .then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || data.error || 'Failed to save');
    setStatusMessage('✅ Video updated successfully!');
    // keep embed updated
    setUrl(url);
  })
  .catch(error => {
    console.error(error);
    setStatusMessage(`❌ Error: ${error.message}`);
  })
  .finally(() => setSaving(false));
};

  // Download subscriber emails as CSV
  const handleDownloadCsv = async () => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${apiUrl}/newsletter/emails/csv`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "text/csv"
      },
    });
    if (res.ok) {
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "subscribers.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      alert("Nem sikerült letölteni a CSV fájlt.");
    }
  };

  if (loading) return <div>Betöltés...</div>;

  return (
    <div>
      <AdminNav />
      <div className="admin-container">
        {user && !user.is_activated ? (
          <div className="approval-message">
            Várj egy admin jóváhagyására! A fiókod még nincs aktiválva.
          </div>
        ) : user && user.is_activated && !user.is_admin ? (
          <div>
            Üdvözlünk! A fiókod aktiválva lett. Feltöltési és posztkezelési funkciókat használhatsz.
          </div>
        ) : (
          <div>
            <div>Üdvözlünk a Főoldalon, {user ? user.username : "Felhasználó"}!</div>
              
          </div>
        )}
      </div>
      {user && user.is_admin && (
        <button
          className="download-csv-btn"
          onClick={handleDownloadCsv}
        >Feliratkozók emailjeinek letöltése (CSV)</button>
      )}
      {user && user.is_admin && (
        <button className="download-csv-btn" onClick={() => navigate('/admin/teamcontrol')}>Csapattagok kezelése</button>
      )}
      {user && user.is_admin && (
        <> {/* <--- Add this opening Fragment */}
        <form onSubmit={handleSubmit} className="video-form">
            <label className="video-label">YouTube videó link vagy ID</label>
            <input 
                className="video-input"
                type="text" 
                value={url} 
                onChange={(e) => setUrl(e.target.value)} 
                placeholder="Pl.: https://www.youtube.com/watch?v=abc123XYZ or abc123XYZ"
                required
            />

            <div className="video-actions">
              <button type="submit" className="video-save" disabled={saving || !url}>
                {saving ? 'Mentés...' : 'Videó mentése'}
              </button>
              <button type="button" className="video-open" onClick={() => embedId && window.open(`https://www.youtube.com/watch?v=${embedId}`, '_blank')}
                disabled={!embedId}>Megnyitás a YouTube-on</button>
            </div>

            {statusMessage && <div className="video-status">{statusMessage}</div>}

            {embedId ? (
              <div className="video-preview">
                <div className="video-responsive">
                  <iframe
                    title="video-preview"
                    src={`https://www.youtube.com/embed/${embedId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            ) : (
              <div className="video-hint">Érvénytelen YouTube link vagy ID — illessz be egy YouTube URL-t vagy videó ID-t.</div>
            )}
        </form>
    </> 
  )}
      <div className="admin-container-stats">
        <p>Jelenlegi cikkek száma:</p>
        <p>{articleCount}</p>
      </div>

    
    </div>
  );
}
